import { TileBase } from "./TileBase";
import { Game, eModelAsset, eSfxSprite, SfxSprites, eAudioAsset } from "../../../Game";
import { eTileType, MapCell } from "../Game Map/MapCell";
import { Player } from "../Player/Player";
import { ViewCellMapCell } from "../View/ViewCellMapCell";
import { ViewCellMap } from "../View/ViewCellMap";
import { Gameplay, eBatchGroup, TIMER } from "../../Gameplay";
import { Pool } from "../../../Utils/Collections/Pool";
import { WrappedArray } from "../../../Utils/Collections/WrapperArray";
import { ModelUtils } from "../../../Utils/ModelUtils";
import { SoundManager } from "../../../Utils/SoundManager";



export class FanTile extends TileBase {
    private static _MODEL_ASSET: pc.Asset;

    /**
     * Sdileny pool s efekty
     */
    private static _AIR_FX_POOL: Pool<FanAirFx>;

    private static readonly _AIR_FX_INTERVAL = 200;

    private _propeller: pc.GraphNode;
    private _airFxs: WrappedArray<FanAirFx>;
    private _nextAirFxTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        if (!FanTile._MODEL_ASSET) {
            // Asset s modelem ventilatoru
            FanTile._MODEL_ASSET = Game.app.assets.find(eModelAsset.tileFan_0, pc.ASSET_MODEL);

            // Sdileny pool s efekty
            FanTile._AIR_FX_POOL = new Pool<FanAirFx>(FanAirFx, 6, true);
        }

        super(eTileType.fan);

        // Nastavit model
        this._entity.model.asset = FanTile._MODEL_ASSET;

        // Ziskat vrtuli
        this._propeller = this._entity.findByName("propeller");

        // Pole s efekty
        this._airFxs = new WrappedArray<FanAirFx>();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(cell: ViewCellMapCell, cellData: MapCell): void {
        super.init(cell, cellData);

        // Aktivovat dlazdici
        ViewCellMap.instance.addTileToActList(this);
        this._nextAirFxTime = TIMER.time;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): void {
        super.release();

        this._airFxs.forEach((fx: FanAirFx) => {
            fx.reset();
            FanTile._AIR_FX_POOL.returnItem(fx);
        });
        this._airFxs.clear(false);
    }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat kolizi s hracem
     */
    //-------------------------------------------------------------------------
    handleCollision(player: Player): boolean {
        if ((this._flags & TileBase.FLAG_HANDLE_COLLISION) != 0 && Math.abs(player.position.z - this._entity.getPosition().z) <= TileBase.SIZE * 0.3) {
            this._flags &= ~TileBase.FLAG_HANDLE_COLLISION;

            // Zahajit skok hrace
            player.startJump();

            return true;
        }

        return false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (this._propeller)
            this._propeller.rotate(0, -8, 0);

        this._airFxs.forEach((fx: FanAirFx) => {
            if (!fx.update()) {
                this._airFxs.remove(false);
                FanTile._AIR_FX_POOL.returnItem(fx);
            }
        });

        if (TIMER.time > this._nextAirFxTime) {
            this._nextAirFxTime = TIMER.time + FanTile._AIR_FX_INTERVAL;
            this.showNewAirFx();
        }

        return true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private showNewAirFx(): void {
        let fx = FanTile._AIR_FX_POOL.getItem();

        fx.show(this._entity);
        this._airFxs.add(fx, true);
    }
}



class FanAirFx {
    private static readonly _LIFE_SPAN = 800;

    private _entity: pc.Entity;
    private _actTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.asset,
            asset: Game.app.assets.find(eModelAsset.fxFan, pc.ASSET_MODEL),
            castShadows: false,
            receiveShadows: false,
            lightmapped: false,
            //batchGroupId: Gameplay.BATCH_GROUP_ID[eBatchGroup.solid_0],
        });
        this._entity.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(fanTile: pc.Entity): void {
        if (this._entity.parent != fanTile)
            this._entity.reparent(fanTile);

        this._entity.setLocalScale(1, 1, 1);
        this._entity.setLocalPosition(0, 0, 0);
        this._entity.enabled = true;

        this._actTime = TIMER.time;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._entity.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        let progress = (TIMER.time - this._actTime) / FanAirFx._LIFE_SPAN;

        if (progress >= 1) {
            this.reset();
            return false;
        }

        let scale = 0.8 + progress * 0.3;

        this._entity.setLocalPosition(0, pc.QuadraticOut(progress), 0);
        this._entity.setLocalScale(scale, scale, scale);

        ModelUtils.setOpacity(this._entity.model, 0.75 - progress * 0.75);

        return true;
    }
}